function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useStoreActions } from "../../../contexts";
import { useQueryState } from "../useQueryState";
import { useFeatureFlags } from "../../useFeatureFlags";
import { QueryKeys } from "../queryKeys";
const buildBillingScheduleQueryParams = params => {
  const queryParams = {};
  if (params !== null && params !== void 0 && params.selectedOptionalServices && params.selectedOptionalServices.length > 0) {
    queryParams.selectedOptionalServices = params.selectedOptionalServices.join(',');
  }
  if (params !== null && params !== void 0 && params.selectedBundleId) {
    queryParams.selectedBundleId = params.selectedBundleId;
  }
  return Object.keys(queryParams).length > 0 ? queryParams : undefined;
};
export const useBillingSchedule = (id, source, shouldRefetch, params) => {
  var _params$selectedOptio;
  const {
    api
  } = useStoreActions();
  const {
    BILLING_SCHEDULE_NEW_UI
  } = useFeatureFlags();
  const {
    data,
    isLoading,
    isBackgroundLoading,
    isFetching,
    error,
    refresh
  } = useQueryState(_objectSpread({
    enabled: !!id && BILLING_SCHEDULE_NEW_UI && !!source,
    queryKey: [QueryKeys.BillingSchedule, id, source, (params === null || params === void 0 || (_params$selectedOptio = params.selectedOptionalServices) === null || _params$selectedOptio === void 0 ? void 0 : _params$selectedOptio.join(',')) || '', (params === null || params === void 0 ? void 0 : params.selectedBundleId) || ''],
    queryFn: () => {
      const queryParams = buildBillingScheduleQueryParams(params);
      switch (source) {
        case 'relationship':
          return api.relationship.getBillingSchedule(id, queryParams);
        case 'draft':
          return api.draft.getBillingSchedule(id, queryParams);
        case 'proposalTemplate':
          return api.proposalTemplates.getBillingSchedule(id, queryParams);
        default:
          return Promise.resolve({
            groups: []
          });
      }
    },
    refreshOnHookMount: source === 'draft' || source === 'proposalTemplate' || shouldRefetch === true
  }, source === 'draft' || source === 'proposalTemplate' || shouldRefetch === true ? {
    keepPreviousData: false
  } : {}));
  return {
    billingSchedule: data,
    isLoading,
    isBackgroundLoading,
    isFetching,
    error,
    refresh
  };
};